import { FormFieldTypes } from "../../../data/formFieldType";

export const createResourcesFormData = {
  name: "CreateResourcesForm",

  initialState: {
    category: null,
    membershipType: null,
    document: "",
    fileUpload: "",
    publishDate: new Date(),
    publishTime: new Date(new Date().setHours(0, 0, 0, 0)),
    removalDate: null,
    removalTime: null,
  },

  formFields: [
    {
      id: "formTitle",
      lable: "Basic Information",
      Field_Name: "formTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "formTitle",
      fieldSetting: {
        formTitle: "Basic Information",
      },
      style: {
        containerCss: "col-12 mb-4 text-left fw-700",
      },
    },

    {
      id: "category",
      lable: "Category",
      Field_Name: "Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "category",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "membershipType",
      lable: "Membership Type",
      Field_Name: "Membership Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "membershipType",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isMultiSelect: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "document",
      lable: "Document",
      Field_Name: "Document",
      fieldType: FormFieldTypes.INPUT,
      dataField: "document",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        maxLength:200
        
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "fileUpload",
      lable: "File for Upload",
      Field_Name: "File for Upload",
      fieldType: FormFieldTypes.INPUT,
      dataField: "fileUpload",
      fieldSetting: {
        placeholder: "Select Document",
        // acceptedFiles: ".pdf, .zip, .ppt, .jpg, .jpeg, .png, .doc, .docx, .xlsx",
        // maxFileSizeInKB: 10240, // 10MB
        queries: "Required file formats are pdf, zip, ppt, jpg/png, doc, xlsx. Max File Size < 10MB",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "uploadButton",
      lable: " ",
      Field_Name: "Upload File",
      fieldType: FormFieldTypes.FILE,
      dataField: "uploadButton",
      fieldSetting: {
        isDownloadable: true,
        placeholder: "Upload",
        acceptedFiles: ".pdf,.zip,.jpg,.jpeg,.png,.doc,.docx,.xlsx,.ppt,.pptx", // if pass .ppt then also need to pass the ".pptx"

        maxFileSizeInKB: 10240, // 10MB
      },
      //  validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 no-star remove-label",
      },
    },
    {
      id: "publishDate",
      lable: "Publish Date",
      Field_Name: "Publish Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "publishDate",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "publishTime",
      lable: "Publish Time",
      Field_Name: "Publish Time",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "publishTime",
      fieldSetting: {
        placeholder: "Select",
        isTime: true,
        isDisable: false,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3 input-margin-space",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: "",
      dataField: "",
      fieldType: FormFieldTypes.COMPONENT,
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3 w-full",
      },
    },
    {
      id: "removalDate",
      lable: "Removal Date",
      Field_Name: "Removal Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "removalDate",
      fieldSetting: {
        placeholder: "Select",
         minDate: new Date(),
      },
      style: {
        containerCss: "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "removalTime",
      lable: "Removal Time",
      Field_Name: "Removal Time",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "removalTime",
      fieldSetting: {
        placeholder: "Select",
        isTime: true,
        isDisable: false,
        minTime: new Date().setHours(0, 0, 0),
      },
      style: {
        containerCss: "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3 input-margin-space",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};


export const viewResourcesDetailFormData = {
  name: "CreateResourcesForm",

  initialState: {
    category: null,
    membershipType: null,
    document: "",
    fileUpload: "",
    publishDate: null,
    publishTime: null,
    removalDate: null,
    removalTime: null,
  },

  formFields: [
    {
      id: "formTitle",
      lable: "Basic Information",
      Field_Name: "formTitle",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "formTitle",
      fieldSetting: {
        formTitle: "Basic Information",
      },
      style: {
        containerCss: "col-12 mb-4 text-left fw-700",
      },
    },

    {
      id: "category",
      lable: "Category",
      Field_Name: "Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "category",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "membershipType",
      lable: "Membership Type",
      Field_Name: "Membership Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "membershipType",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isMultiSelect: true,
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "document",
      lable: "Document",
      Field_Name: "Document",
      fieldType: FormFieldTypes.INPUT,
      dataField: "document",
      fieldSetting: {
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "fileUpload",
      lable: "File for Upload",
      Field_Name: "File for Upload",
      fieldType: FormFieldTypes.INPUT,
      dataField: "fileUpload",
      fieldSetting: {
        placeholder: "Select Document",
        // acceptedFiles: ".pdf, .zip, .ppt, .jpg, .jpeg, .png, .doc, .docx, .xlsx",
        // maxFileSizeInKB: 10240, // 10MB
        queries: "Required file formats are pdf, zip, ppt, jpg/png, doc, xlsx. Max File Size < 10MB",
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "uploadButton",
      lable: " ",
      Field_Name: "Upload File",
      fieldType: FormFieldTypes.FILE,
      dataField: "uploadButton",
      fieldSetting: {
        placeholder: "Upload",
        acceptedFiles: ".pdf, .zip, .ppt, .jpg, .jpeg, .png, .doc, .docx, .xlsx",
        maxFileSizeInKB: 10240, // 10MB
      },
      //  validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12 no-star remove-label",
      },
    },
    {
      id: "publishDate",
      lable: "Publish Date",
      Field_Name: "Publish Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "publishDate",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "publishTime",
      lable: "Publish Time",
      Field_Name: "Publish Time",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "publishTime",
      fieldSetting: {
        placeholder: "Select",
        isTime: true,
        // isDisable:false,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3 input-margin-space",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: "",
      dataField: "",
      fieldType: FormFieldTypes.COMPONENT,
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3 w-full",
      },
    },
    {
      id: "removalDate",
      lable: "Removal Date",
      Field_Name: "Removal Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "removalDate",
      fieldSetting: {
        placeholder: "Select",
      },
      style: {
        containerCss: "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3",
      },
    },
    {
      id: "removalTime",
      lable: "Removal Time",
      Field_Name: "Removal Time",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "removalTime",
      fieldSetting: {
        placeholder: "Select",
        isTime: true,
        // isDisable:true,
      },
      style: {
        containerCss: "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-3 input-margin-space",
      },
    },
  ],

  formSetting: {
    isViewOnly: true,
  },
};